import type { Vec3 } from './vec';

export interface Zone {
  min: Vec3;
  max: Vec3;
}

/** Strictly inside the zone (by the player's origin). */
export function inZone(z: Zone, p: Readonly<Vec3>): boolean {
  return (
    p[0] > z.min[0] &&
    p[0] < z.max[0] &&
    p[1] > z.min[1] &&
    p[1] < z.max[1] &&
    p[2] > z.min[2] &&
    p[2] < z.max[2]
  );
}
